import state from './state'
import mutations from './mutation'
import getters from './getter'

export default {
    state,
    mutations,
    getters,
}